module.exports = function(app) {
    app.directive('hipaaDrawer',
        function() {

            return {
                restrict: 'A',
                replace: true,
                //template: require('directives/hipaaDrawer.html'),
                templateUrl: 'hipaa.appTemplate.html/chmhom/directives/hipaaDrawer',

                scope: {
                    material: '=hipaaDrawer',
                    section: '='
                },


                controller: ['$scope','coremetrics', function($scope,coremetrics) {
                    var material = $scope.material;

                    $scope.isVideo = material.type === 'video';
                    $scope.isPDF = material.type === 'pdf';

                    var videoClicked;
                    $scope.emPlayVideoCoremetrics = function(){

                    };

                    $scope.emDownloadPDFCoremetrics = function(){


                    };

                    if ($scope.isPDF) {
                        material.url = material.linkHref;
                    }
                }]
            };
        }
    );
};